import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import OrderService from "./services/orders";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { default as Adal, AxiosAuthHttp } from "vue-adal";
import axios from "axios";
const graphApiResource = "2079fec8-1a8a-4ab4-8b4b-48f0a0b71cca";
const graphApiBase = "https://admin.jeparts.info/";
//const graphApiBase = "http://localhost:8080";

Vue.use(BootstrapVue);

Vue.use(OrderService, { limit: 50 });

Vue.use(Adal, {
  config: {
    tenant: "5280e0c8-fec5-4be4-a7b3-3c37f1774bde",
    clientId: "2079fec8-1a8a-4ab4-8b4b-48f0a0b71cca",
    redirectUri: graphApiBase,
    cacheLocation: "localStorage"
  },
  requireAuthOnInitialize: true,
  router: router
});

Vue.use({
  install(vue, opts = {}) {
    vue.prototype.$graphApi = AxiosAuthHttp.createNewClient({
      axios: axios,
      resourceId: graphApiResource, // Resource id to get a token against
      router: router, // Enables a router hook to auto-acquire a token for the specific resource
      baseUrl: graphApiBase, // Base url to configure the client with

      onTokenSuccess(http, context, token) {
        store.commit("setToken", token);
        //load state

        store.dispatch("loadAllEmployees");
        store.dispatch("loadConfigs");
        store.dispatch("loadAllCustomers");
      },

      onTokenFailure(error) {
        store.commit("setToken", "");
        console.log(error);
      }
    });
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
